<template>
  <div>
    {{ /* eslint-disable-next-line */ }}
    <ui-save-bar v-if="isShopify" ref="polarisBar">
      <button
        :loading="discardLoading"
        :disabled="saveLoading || discardLoading"
        @click="handleDiscard"
      >
        Discard
      </button>
      <button
        :disabled="saveActions?.disabled || saveLoading || discardLoading"
        :loading="saveLoading"
        @click="
          saveLoading = true;
          setNextRoute(null);
          saveActions.save();
        "
        variant="primary"
      >
        Save
      </button>
    </ui-save-bar>
    <p-box
      v-else
      v-show="saveActions"
      background="bg-surface"
      overflowX="clip"
      overflowY="clip"
      :padding="{ xs: 400 }"
      style="
        --pc-box-border-radius: var(--p-border-radius-200);
        --pc-box-shadow: var(--p-shadow-200);
      "
      class="shopify-savebar gap-4 justify-end"
    >
      <p-btn
        :disabled="saveLoading || discardLoading"
        @click="handleDiscard"
        :loading="discardLoading"
        >Discard</p-btn
      >
      <p-btn
        :disabled="saveActions?.disabled || saveLoading || discardLoading"
        :loading="saveLoading"
        @click="
          saveLoading = true;
          saveActions.save();
        "
        variant="primary"
        >Save</p-btn
      >
    </p-box>
    <p-dialog
      :value="!!nextRoute"
      @input="setNextRoute(null)"
      @continue="handleForceContinue"
      :title="$t('Home.unsavedChangesTitle')"
    >
      <div class="pb-2 font-medium text-lg">
        {{ $t('Home.unsavedChangesMessage') }}
      </div>
      <div class="pb-2">{{ $t('Home.unsavedChangesConfirm') }}</div>
      <template #footer>
        <p-btn @click="setNextRoute(null)">{{ $t('Common.cancel') }}</p-btn>
        <p-btn variant="primary" @click="handleForceContinue">{{
          $t('Onboarding.continue')
        }}</p-btn>
      </template>
    </p-dialog>
  </div>
</template>

<script>
import PBox from '@/components/polaris/PBox.vue';
import PBtn from '@/components/polaris/PBtn.vue';
import PDialog from '@/components/polaris/PDialog.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'ShopifySavebar',
  components: { PDialog, PBtn, PBox },
  data() {
    return {
      saveActions: null,
      saveLoading: false,
      discardLoading: false,
    };
  },
  computed: {
    ...mapState('app', ['isFormChanged', 'nextRoute', 'menuRoot', 'manualHistory']),
    isShopify() {
      return !!window.shopify || !!window.Shopify;
    },
  },
  beforeDestroy() {
    window.removeEventListener('saveform-changed', this.handleSaveformChanged);
  },
  methods: {
    ...mapMutations('app', ['setFormChanged', 'setNextRoute', 'addManualHistory']),
    handleForceContinue() {
      this.setFormChanged(false);
      // if (
      //   !this.manualHistory.length ||
      //   this.nextRoute.name !== this.manualHistory.slice(-1)[0].name
      // ) {
      // this.addManualHistory(this.$route);
      // }
      this.$router.push(this.nextRoute);
    },
    handleSaveformChanged(ev) {
      if (this.$refs.polarisBar) {
        const action = ev.detail ? 'show' : 'hide';
        this.$refs.polarisBar[action]();
      }

      this.saveActions = ev.detail;
      this.setFormChanged(!!ev.detail);
      if (!ev.detail) {
        this.saveLoading = false;
        this.discardLoading = false;
      }
    },

    handleDiscard() {
      this.setNextRoute(null);
      this.discardLoading = true;
      this.saveActions?.discard?.();

      if (this.$refs.polarisBar) {
        this.$refs.polarisBar.hide();
      }
      this.saveActions = null;
      this.setFormChanged(false);
      this.saveLoading = false;
      this.discardLoading = false;
    },
  },

  mounted() {
    window.addEventListener('saveform-changed', this.handleSaveformChanged);
  },
};
</script>

<style scoped lang="scss">
.shopify-savebar {
  position: fixed;
  display: flex;
  bottom: 2rem;
  left: 6rem;
  right: 6rem;
  z-index: 90;
}
</style>
